/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const actions = {
  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  updateSidebarWidth({ commit }, width) {
    commit('UPDATE_SIDEBAR_WIDTH', width);
  },
  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY');
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val);
  },
  updateUserRole({ commit }, val) {
    commit('UPDATE_USER_ROLE', val);
  },
  updateWindowWidth({ commit }, width) {
    commit('UPDATE_WINDOW_WIDTH', width);
  },

  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload);
  },

  //  The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list);
  },

  updateLogo({ commit }, value) {
    commit('UPDATE_LOGO', value);
  },
  updateFavicon({ commit }, value) {
    commit('UPDATE_FAVICON', value);
  },
  updateListEmpresa({ commit }, value) {
    commit('UPDATE_LIST_EMPRESA', value);
  },
  updateSelectedEmpresa({ commit }, value) {
    commit('UPDATE_SELECTED_EMPRESA', value);
  },
  updateCurrentEmpresa({ commit }, value) {
    commit('UPDATE_CURRENT_EMPRESA', value);
  },
  updateIdUsuarioInitialLogin({ commit }, value) {
    commit('UPDATE_ID_USUARIO_INITIAL_LOGIN', value);
  },
  updateNomeCurrentUsuario({ commit }, value) {
    commit('UPDATE_NOME_CURRENT_USUARIO', value);
  },
  updateCountBadgeNewItems({ commit }, valeu) {
    commit('UPDATE_COUNT_BADGE_NEW_ITEMS', valeu);
  },
  updateProfilePic({ commit }, value) {
    commit('UPDATE_PROFILE_PIC', value);
  },
};

export default actions;
